// Generated from src/img/svg/ubahn.svg

export const Ubahn = (props) => {
  return (
    <svg viewBox="0 0 25 25" {...props}>
      <path d="M0 0h25v25H0z" style={{ fill: "#006bb2" }} />
      <path
        d="M9.497 3.173V14.28c0 2.943 1.116 4.44 3.095 4.44 2.03 0 3.146-1.421 3.146-4.44V3.173h3.857v10.853c0 5.277-2.664 7.789-7.13 7.789-4.313 0-6.85-2.385-6.85-7.84V3.173Z"
        style={{ fill: "#fff" }}
      />
    </svg>
  );
};
